import { ChipProps, Tone } from './props.js'
import { CheckIcon } from './icons.js'

// Tone tints only TEXT, never background. Typed over the full `Tone` union
// (not just the tones this component happened to need at the time) so
// adding a tone anywhere else is a compile error here until it's given a
// colour too — teal was added for the 'completed' jobcard status and silently
// fell back to neutral here for a while, because this map was `Record<string,
// string>` and had nothing to enforce completeness.
const TONE_TEXT: Record<Tone, string> = {
  neutral: 'text-on-surface-variant',
  primary: 'text-primary',
  secondary: 'text-on-surface-variant',
  success: 'text-success',
  error: 'text-error',
  warning: 'text-warning',
  info: 'text-info',
  violet: 'text-violet',
  teal: 'text-teal',
}

export function Chip({
  label,
  tone = 'neutral',
  selected = false,
  onClick,
  icon,
  className = '',
}: ChipProps) {
  const textColor = TONE_TEXT[tone]

  const baseClasses = [
    'inline-flex items-center gap-2',
    'rounded-full px-2.5 py-1',
    'text-label-md transition-all interactive whitespace-nowrap',
    'focus-visible:outline-2 focus-visible:outline-offset-2',
  ]
    .filter(Boolean)
    .join(' ')

  const bgClasses = selected
    ? 'bg-primary text-on-primary'
    : `bg-surface-highest ${textColor}`

  const finalClassName = [
    baseClasses,
    bgClasses,
    onClick && 'cursor-pointer',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const content = (
    <>
      {selected && <CheckIcon className="w-5 h-5" />}
      {icon && !selected && icon}
      <span>{label}</span>
    </>
  )

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={finalClassName}
      >
        {content}
      </button>
    )
  }

  return <div className={finalClassName}>{content}</div>
}
